import React from 'react'
import "./Loader.css"
import { useAuth } from '../../Context/store/context'


export default function Loader() {
  const { loadingMessage } = useAuth();

  return (
    <>
      <div className="preloader">
        <div className="vertical-centered-box">
            <div className="content">
              <div className="loader-circle"></div>
              <div className="loader-line-mask">
                <div className="loader-line"></div>
              </div>
              <img src="/images/loader.png" alt="" />
            </div>
        </div>
        <div className='messagediv'>
        <h4 className="message">{loadingMessage}</h4>
        </div>
      </div>
    </>
  )
}
